/**
 * Compact multi-step indicator for ≤768px. The full `.onboard-progress` 5-cell
 * strip is `display:none` on phone (responsive layer in index.css); this shows
 * "Step 3 of 5 · Items & tax" + a progress bar instead, and is itself
 * `display:none` on desktop. Render it directly above the `.onboard-progress`
 * strip in any multi-step page.
 */
export function StepCompact({
  steps,
  current,
  onJump,
}: {
  steps: Array<{ name: string }>;
  current: number;
  onJump?: (i: number) => void;
}) {
  const pct = steps.length > 1 ? Math.round((current / (steps.length - 1)) * 100) : 100;
  return (
    <div className="step-compact">
      <div className="step-compact-row">
        <span className="step-compact-label">
          Step {current + 1} of {steps.length}
        </span>
        <span className="step-compact-name">{steps[current]?.name}</span>
        {onJump && current > 0 && (
          <button
            type="button"
            className="step-compact-back"
            onClick={() => onJump(current - 1)}
          >
            ‹ Back
          </button>
        )}
      </div>
      <div className="step-compact-bar">
        <div className="step-compact-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
